export default __webpack_public_path__ + "static/Room-With-A-View-Statue-of-Liberty-12928c58ec1f7fdb3c4fa23636d3b673.jpg";